import { FC } from 'react'

import SafetyCaseHazardPopUpContent from '../safety-case-hazard-pop-up-content'

import { ISafetyCaseHazard } from '../../../interfaces'

type SafetyCaseHazardPopupProps = {
  safetyCaseHazard?: ISafetyCaseHazard
  onNavigateToSafetyCaseHazard?: (safetyCaseHazard?: ISafetyCaseHazard) => void
  onNavigateToSafetyCase?: (safetyCaseHazard?: ISafetyCaseHazard) => void
}

const SafetyCaseHazardPopup: FC<SafetyCaseHazardPopupProps> = props => {
  const { safetyCaseHazard, onNavigateToSafetyCaseHazard, onNavigateToSafetyCase } = props

  if (!safetyCaseHazard) {
    return null
  }

  return (
    <>
      <div className="border-bottom text-center w-100 mb-2">
        <button
          className="btn btn-link p-0 text-decoration-none"
          onClick={() => onNavigateToSafetyCaseHazard?.(safetyCaseHazard)}
        >
          <h5>Safety Hazard #{safetyCaseHazard?.id}</h5>
        </button>
      </div>

      <SafetyCaseHazardPopUpContent
        safetyCaseHazard={safetyCaseHazard}
        onNavigateToSafetyCase={onNavigateToSafetyCase}
      />
    </>
  )
}

export default SafetyCaseHazardPopup
